<!--
* @Name：定价方式审批基本页面
* @Author: 王超
* @Date: 2025-09-17 10:39:49
* @Last Modified by: 王超
* @Last Modified time: 2025-09-17 10:39:49
-->
<template>
  <div>
    <hi-card v-for="(item, index) in bidList" :key="item.poCreateItemId" :row-index="index + 1">
      <van-row>
        <span>标的序号：</span>
        <span>{{ item.subjectNo }}</span>
      </van-row>
      <van-row>
        <span>物料编码：</span>
        <span>{{ item.materialId }}</span>
      </van-row>
      <van-row>
        <span>物料描述：</span>
        <span>{{ item.materialDesc }}</span>
      </van-row>
      <van-row v-if="buttonNoBOM || buttonTry">
        <span>申请单号：</span>
        <span>{{ item.demandCode }}</span>
      </van-row>
      <van-row>
        <span>供货品类：</span>
        <span>{{ item.catgName }}</span>
      </van-row>
      <van-row>
        <span>物料信息补充：</span>
        <span>{{ item.materialExt }}</span>
      </van-row>
      <van-row>
        <span>基本单位：</span>
        <span>{{ item.unit }}</span>
      </van-row>
      <van-row>
        <span>基本单位说明：</span>
        <span>{{ item.unitInfo }}</span>
      </van-row>
      <van-row>
        <span>采购数量：</span>
        <span>{{ item.quantity }}</span>
      </van-row>
      <van-row>
        <span>目标税率：</span>
        <span>{{ item.targetTax }}</span>
      </van-row>
      <van-row>
        <span>上次采购价格：</span>
        <span>{{ item.lastTimePrice }}</span>
      </van-row>
      <van-row>
        <span>预估价格：</span>
        <span>{{ item.predictPrice }}</span>
      </van-row>
      <van-row>
        <span>价格失效规则：</span>
        <span>{{ item.expireRuleName }}</span>
      </van-row>
      <van-row>
        <span>需求部门：</span>
        <span>{{ item.deptName }}</span>
      </van-row>
      <van-row>
        <span>交货地点：</span>
        <span>{{ item.destination }}</span>
      </van-row>
      <van-row v-if="showTempCode">
        <span>临时编码：</span>
        <span>{{ item.tempCode }}</span>
      </van-row>
      <van-row v-if="buttonTry">
        <span>申请人：</span>
        <span>{{ item.applicant }}</span>
      </van-row>
      <van-row v-if="buttonTry">
        <span>技术联系人：</span>
        <span>{{ item.techPerson }}</span>
      </van-row>
      <van-row v-if="showStepPrice">
        <van-button type="info" size="normal" style="margin-bottom: 5px" @click="clickPriceList(item)"
          >阶梯价格设定</van-button
        >
      </van-row>
      <van-row>
        <van-button type="info" size="normal" style="margin-bottom: 5px" @click="clickAttachmentList(item)"
          >图纸附件</van-button
        >
      </van-row>
      <van-row>
        <van-button type="info" size="normal" @click="clickOtherAttachmentList(item)">其他附件</van-button>
      </van-row>
    </hi-card>
    <attachment-info
      v-if="attachmentDialogVisible"
      :details-visible="attachmentDialogVisible"
      :attach-list="attachmentListItem"
      @close-details-dialog="attachmentDialogVisible = false"
    />
    <attachment-info
      v-if="otherAttachmentDialogVisible"
      :details-visible="otherAttachmentDialogVisible"
      :attach-list="otherAttachmentListItem"
      @close-details-dialog="otherAttachmentDialogVisible = false"
    />
    <stage-price-info
      v-if="priceDialogVisible"
      :details-visible="priceDialogVisible"
      :price-list="priceListItem"
      @close-details-dialog="priceDialogVisible = false"
    />
  </div>
</template>

<script>
import { getAttachmentFileUrl, queryMatFile } from '@/api/pmPriceCompApproval'
export default {
  name: 'BidInfo',
  components: {
    'attachment-info': () => import('./AttachmentInfo'),
    'stage-price-info': () => import('./StagePriceInfo')
  },
  data() {
    return {
      attachmentDialogVisible: false,
      otherAttachmentDialogVisible: false,
      priceDialogVisible: false,
      attachmentListItem: [],
      otherAttachmentListItem: [],
      priceListItem: []
    }
  },
  props: {
    bidList: {
      type: Array,
      required: true
    },
    pcType: {
      type: String,
      required: true
    },
    tieredPrice: {
      type: String,
      required: true
    }
  },
  computed: {
    showTempCode() {
      return this.pcType === '3' || this.pcType === '4' || this.pcType === '6'
    },
    showStepPrice() {
      return this.tieredPrice !== '0'
    },
    buttonBOM() {
      return this.pcType === '1' || this.pcType === '5'
    },
    buttonNoBOM() {
      return this.pcType === '2'
    },
    buttonTry() {
      return this.pcType === '3' || this.pcType === '4'
    }
  },
  methods: {
    async clickAttachmentList(item) {
      this.attachmentListItem = []
      // 有物料编码需要先获取图纸附件列表
      if (item.materialId) {
        const response = await queryMatFile({ itemcode: item.materialId })
        const list = response.data.rows
        if (list.length > 0) {
          list.forEach(fileItem => {
            this.attachmentListItem.push({
              url: fileItem.fileUrl,
              fullName: fileItem.fileName
            })
          })
        }
      } else {
        // 无物料编码，图纸附件信息在行明细
        this.attachmentListItem = item.filePaths
      }
      if (this.attachmentListItem.length > 0) {
        // 图纸附件获取下载key，将格式转为附件列表格式
        for (const attListItem of this.attachmentListItem) {
          const response = await getAttachmentFileUrl({
            encodedUrl: encodeURIComponent(attListItem.url),
            fileFullName: attListItem.fullName
          })
          this.$set(attListItem, 'attachName', attListItem.fullName)
          this.$set(attListItem, 'attachPath', response.data)
        }
      }
      this.attachmentDialogVisible = true
    },
    clickOtherAttachmentList(item) {
      this.otherAttachmentListItem = item.subjectFiles
      this.otherAttachmentDialogVisible = true
    },
    clickPriceList(item) {
      this.priceListItem = item.tieredPriceDetailList
      this.priceDialogVisible = true
    }
  }
}
</script>
